import type {RouteRecordRaw} from "vue-router";
import {route as Incoming} from "./incoming";
import {route as Outgoing} from "./outgoing";
import {route as CreateDocument} from './create';
import {route as EditDocument} from './edit';
import {route as DocumentInfo} from './info';
import {route as DocumentDraft} from './draft';
import {route as DocumentTrash} from './trash';
import {route as CabinetTariffs} from './tariffs';
import {route as CabinetMain, routeName as cabinetMainRouteName} from './main';
import {route as CabinetService} from './services_mobile';
import {route as NotificationMobile} from './notification';
import {route as CabinetPermissions, employeeRoute as CabinetPermissionsEmployee} from './permissions';

import FolderIcon from "@/shared/ui/icons/document/Folders.vue";
import BriefcaseIcon from "@/shared/ui/icons/user/BriefcaseOutline.vue";

export const routeName = 'Cabinet';

export const route: RouteRecordRaw = {
    name: routeName,
    path: '/cabinet',
    component: () => import('@/pages/Cabinet'),
    meta: {
        requiresAuth: true,
    },
    beforeEnter: (to, _, next) => {
        if (to.name === routeName) {
            return next({name: cabinetMainRouteName});
        }
        next();
    },
    children: [
        Incoming,
        Outgoing,
        CreateDocument,
        EditDocument,
        DocumentInfo,
        DocumentDraft,
        DocumentTrash,
        CabinetTariffs,
        CabinetMain,
        CabinetService,
        NotificationMobile,
        CabinetPermissions,
        CabinetPermissionsEmployee,
        {
            name: 'CopyDocument',
            path: 'copy/:id(\\d+)',
            component: () => import('@/pages/CopyDocument'),
            props: route => ({id: Number(route.params.id)}),
            meta: {
                isHide: true,
            }
        },
        {
            name: 'Folder',
            path: 'folder/:id?',
            component: () => import('@/pages/Folders'),
            props: true,
            meta: {
                title: 'folders',
                icon: FolderIcon,
                isNavTab: true,
                divider: 'before',
            },
        },
        {
            name: 'Counterparty',
            path: 'counterparty',
            component: () => import('@/pages/Counterparty'),
            props: true,
            meta: {
                title: 'counterparty',
                icon: BriefcaseIcon,
                isNavTab: true,
                isNew: false,
            },
        },
        {
            name: 'Subscription',
            path: 'subscription',
            alias: 'payments',
            component: () => import('@/pages/Subscription'),
            meta: {
                isHide: true,
            },
        },
        {
            name: 'CreateByTemplate',
            path: 'create/:docId(\\d+)/template/:templateId(\\d+)/:fileId(\\d+)?',
            component: () => import('@/pages/CreateWithTemplate'),
            props: route => ({
                docId: Number(route.params.docId),
                templateId: Number(route.params.templateId),
                fileId: route.params.fileId ? Number(route.params.fileId) : undefined
            }),
            meta: {
                isHide: true,
            },
        },
        {
            path: ':pathMatch(.*)*',
            name: 'NotFoundInCabinet',
            component: () => import("@/pages/NotFound"),
            props: {
                cabinet: true,
            },
            meta: {
                isHide: true,
            }
        },
    ]
};
